import Service from '@ember/service';

export default class MemoryScrollService extends Service {}


declare module '@ember/service' {
  interface Registry {
    'memory-scroll': MemoryScrollService;
  }
}